import React, { useContext } from "react";
import { debug } from "../utils";
import { connect } from "react-redux";
import { CheckboxTable } from "../view/CheckboxTable";
import { useMlDetectionTableHelper } from "./useMlDetectionTableHelper";
import MlDetectionTableRow from "./MlDetectionTableRow";
import MlDetectionTableRowSkeleton from "./MlDetectionTableRowSkeleton";
import { TableContext } from "../index";

function MlDetectionTable({ mlDetectionResulstList }) {

    const helper = useMlDetectionTableHelper();
    const { config } = useContext(TableContext);
    //const viewMode = config.viewMode || "login";

    // Client-side filtering based on searchTerm from context
    // const filteredResults = mlDetectionResulstList.filter((item) => {
    //     const service = (item.service || '').toLowerCase();
    //     if (viewMode === "config" && service !== 'config-action') return false;
    //     if (viewMode === "login" && service === 'config-action') return false;

    //     const term = (config.searchTerm || '').toLowerCase();
    //     if (!term) return true;

    //     const date = (item.date || '').toLowerCase();
    //     const ip = (item.ip || '').toLowerCase();
    //     const usr = (item.usr || '').toLowerCase();
    //     const note = (item.note || '').toLowerCase();
    //     const result = (item.detectionResults || '').toLowerCase();

    //     return date.includes(term) || ip.includes(term) || usr.includes(term) || note.includes(term) || result.includes(term) || service.includes(term);
    // });

    const filteredResults = mlDetectionResulstList.filter((item) => {
        const term = (config.searchTerm || '').toLowerCase();
        if (!term) return true;

        const date = (item.date || '').toLowerCase();
        const ip = (item.ip || '').toLowerCase();
        const usr = (item.usr || '').toLowerCase();
        const note = (item.note || '').toLowerCase();
        const result = (item.detectionResults || '').toLowerCase();

        return date.includes(term) || ip.includes(term) || usr.includes(term) || note.includes(term) || result.includes(term);
    });

    //const detailHeader = viewMode === "config" ? "DETAIL / IMPACT" : "DETAIL";

    // const headers = [
    //     { name: 'DATE', sortKey: 'date', onClick: () => helper.onDetectionDateClick() },
    //     { name: 'IP', sortKey: 'ip', onClick: () => helper.onIPClick() },
    //     { name: 'USER', sortKey: 'usr', onClick: () => helper.onUserClick() },
    //     { name: detailHeader, sortKey: 'note', onClick: () => helper.onDetailsClick() },
    //     { name: 'RESULT', sortKey: 'detectionResults', onClick: () => helper.onResultClick() },
    //     // { name: 'ACTIONS' }
    // ]

    const headers = [
        { name: 'DATE', sortKey: 'date', onClick: () => helper.onDetectionDateClick() },
        { name: 'IP', sortKey: 'ip', onClick: () => helper.onIPClick() },
        { name: 'USER', sortKey: 'usr', onClick: () => helper.onUserClick() },
        { name: 'DETAIL', sortKey: 'note', onClick: () => helper.onDetailsClick() },
        { name: 'RESULT', sortKey: 'detectionResults', onClick: () => helper.onResultClick() },
        // { name: 'ACTIONS' }
    ]

    // return (
    //     <>
    //         <CheckboxTable className="mt-4" headers={headers} elements={filteredResults}>
    //             {config.isLoading ? (
    //                 Array.from(new Array(10)).map((_, index) => (
    //                     <MlDetectionTableRowSkeleton key={index} index={index} />
    //                 ))
    //             ) : (
    //                 filteredResults.map((data, index) => <MlDetectionTableRow key={index} data={data} index={index} />)
    //             )}
    //         </CheckboxTable>
    //         {!config.isLoading && !!config.loadError && (
    //             <div className="oct_hint modal-v2-hint modal-v2-hint-warning mt-3">
    //                 <div>
    //                     <strong>Results API unavailable.</strong> {config.loadError}
    //                 </div>
    //             </div>
    //         )}
    //         {!config.isLoading && filteredResults.length === 0 && (
    //             <div className="oct_empty-state-v2">
    //                 <div className="oct_empty-state-title">{config.loadError ? 'No ML data loaded' : 'No records found'}</div>
    //                 <div>
    //                     {config.loadError
    //                         ? 'The page is still usable, but the report service needs to be running for AIML results to appear.'
    //                         : "Try adjusting your search or filters to find what you're looking for."}
    //                 </div>
    //             </div>
    //         )}
    //     </>
    // );

    return (
        <>
            <CheckboxTable className="mt-4" headers={headers} elements={filteredResults}>
                {config.isLoading ? (
                    Array.from(new Array(10)).map((_, index) => (
                        <MlDetectionTableRowSkeleton key={index} index={index} />
                    ))
                ) : (
                    filteredResults.map((data, index) => <MlDetectionTableRow key={index} data={data} index={index} />)
                )}
            </CheckboxTable>
            {!config.isLoading && filteredResults.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    );
}

function mapStateToProps(state) {
    debug("MlDetectionTable mapStateToProps", state);
    const mlDetectionPage = state.mlDetectionPage;
    return {
        mlDetectionResulstList: mlDetectionPage.results || []
    };
}

export default connect(mapStateToProps)(MlDetectionTable);
